import BaseModelAPI from '../BaseModelAPI';

export default class DeliveryQualityInspectionDetail extends BaseModelAPI {
	static entity = 'deliveryqualityinspectiondetail';
	static entityName = 'deliveryqualityinspectiondetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.deliveryQualityInspectionId = '';
			this.deliveryQualityInspection = {};
			this.deliveryInstructionDetailId = '';
			this.deliveryInstructionDetail = {};
			this.partId = '';
			this.part = {};
			this.qtyDeliver = 0;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
			this.inspectionStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}